import { useState, useEffect } from 'react';
import '../../styles/components/management/AuditLogs.css';

const API_BASE = process.env.REACT_APP_API_BASE;

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const [userFilter, setUserFilter] = useState('');
  const [actionFilter, setActionFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [availableUsers, setAvailableUsers] = useState([]);

  // Fetch once on mount
  useEffect(() => {
    async function fetchLogs() {
      try {
        const res = await fetch(`${API_BASE}/app/API/rbmgt/AuditLogs.php`);
        const data = await res.json();
        if (data.success) {
          setLogs(data.logs);
          setFilteredLogs(data.logs);
          setAvailableUsers([...new Set(data.logs.map(log => log.USER_NAME))]);
        } else {
          console.error('Failed to load audit logs:', data.message);
        }
      } catch (err) {
        console.error('Error fetching audit logs:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchLogs();
  }, []);

  // Re-apply filters whenever logs or any filter changes
  useEffect(() => {
    let out = logs;

    if (userFilter) {
      out = out.filter(log => log.USER_NAME === userFilter);
    }

    if (actionFilter.trim()) {
      out = out.filter(log =>
        log.ACTION.toLowerCase().includes(actionFilter.trim().toLowerCase())
      );
    }

    if (dateFilter) {
      out = out.filter(log =>
        log.TIMESTAMP.startsWith(dateFilter)
      );
    }

    setFilteredLogs(out);
  }, [logs, userFilter, actionFilter, dateFilter]);

  return (
    <div className="audit-logs">
      <div className="filters">
        <select value={userFilter} onChange={e => setUserFilter(e.target.value)}>
          <option value="">All Users</option>
          {availableUsers.map(user => (
            <option key={user} value={user}>{user}</option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Filter by Action"
          value={actionFilter}
          onChange={e => setActionFilter(e.target.value)}
        />

        <input
          type="date"
          value={dateFilter}
          onChange={e => setDateFilter(e.target.value)}
        />
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Date/Time</th>
                <th>User</th>
                <th>Action</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.map(log => (
                <tr key={log.LOG_ID}>
                  <td>{log.TIMESTAMP}</td>
                  <td>{log.USER_NAME}</td>
                  <td>{log.ACTION}</td>
                  <td>{log.DETAILS}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
